export const AGENT_TYPE = [
  { id: 'Calculation Agent', displayValue: 'Calculation Agent' },
  { id: 'Lead Manager', displayValue: 'Lead Manager' },
  { id: 'Paying Agent', displayValue: 'Paying Agent' },
  { id: 'Registrar', displayValue: 'Registrar' },
  { id: 'Clearing', displayValue: 'Clearing' },
  { id: 'Dealer', displayValue: 'Dealer' },
  { id: 'Guarantor', displayValue: 'Guarantor' },
];
